import { withFormControl } from './withFormControl';
import { Input } from '@chakra-ui/react';

export const TextFormControl = withFormControl(props => {
   return <Input type="text" bg="white" {...props} />;
});
